import React, { useState } from 'react';

const NotificationItem = ({ 
  notification, 
  onMarkAsRead, 
  onMarkAsUnread, 
  onDelete,
  formatTimestamp,
  getPriorityColor,
  getTypeIcon
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAction = async (action, ...args) => {
    setIsLoading(true);
    try {
      await action(...args);
    } catch (error) {
      console.error('Error performing action:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNotificationClick = () => {
    // Mark as read when clicked
    if (!notification.isRead) {
      handleAction(onMarkAsRead, notification._id);
    }

    // Navigate to action URL if available
    if (notification.actionUrl) {
      window.location.href = notification.actionUrl;
    }
  };

  return (
    <div
      className={`p-4 hover:bg-gray-50 transition-colors cursor-pointer relative ${
        !notification.isRead ? 'bg-blue-50' : ''
      }`}
      onClick={handleNotificationClick}
    >
      <div className="flex items-start space-x-3">
        {/* Icon and Priority Indicator */}
        <div className={`flex-shrink-0 p-2 rounded-full ${getPriorityColor(notification.priority)}`}>
          {getTypeIcon(notification.type)}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Title and Menu */}
          <div className="flex items-start justify-between">
            <h4 className={`text-sm font-medium text-gray-900 ${!notification.isRead ? 'font-semibold' : ''}`}>
              {notification.title}
            </h4>
            
            {/* Delete Button */}
            <div className="relative flex-shrink-0 ml-2">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onDelete, notification._id);
                }}
                className="p-1 text-gray-400 hover:text-red-600 rounded transition-colors"
                disabled={isLoading}
                title="Delete notification"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Message */}
          <p className="mt-1 text-sm text-gray-600 line-clamp-2">
            {notification.message}
          </p>

          {/* Metadata */}
          <div className="mt-2 flex items-center justify-between text-xs text-gray-500">
            <div className="flex items-center space-x-2">
              {/* Priority Badge */}
              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(notification.priority)}`}>
                {notification.priority}
              </span>

              {/* Type */}
              <span className="capitalize">
                {notification.type.replace(/_/g, ' ')}
              </span>
            </div>

            {/* Timestamp */}
            <span>
              {formatTimestamp(notification.createdAt)}
            </span>
          </div>

        </div>
      </div>

      {/* Loading Overlay */}
      {isLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center">
          <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

    </div>
  );
};

export default NotificationItem;
